export default __webpack_public_path__ + "static/media/article_img_04.34674e65.png";